import React from 'react'
import { observer } from 'mobx-react-lite'
import { Label, Text, Col } from '@evertel/web/ui'
import classNames from 'classnames'

interface WrapperProps {
    value?: string|string[]|Record<string, any>
    title?: string
    hint?: string
    description?: string
    required?: boolean
    empty?: string
    errors?: string
    children?: React.ReactNode
    className?: string
    labelId?: string
    descriptionId?: string
    labelClassName?: string
    errorId?: string
}

const Wrapper: React.FC<WrapperProps> = observer(({
    value,
    title,
    hint,
    description,
    required,
    empty,
    errors,
    children,
    labelId,
    descriptionId,
    errorId,
    labelClassName,
    ...otherProps
}) => {

    // Why did this line ever exist? TODO: remove if all is good
    // title = (value !== '' || empty !== '') ? title : undefined

    // So, a whole load of props are sent here that were when one widget glitches and gets a different widgets props.
    // @ts-expect-error: shush: want properties removed so they don't throw errors on dom
    const { componentType, contentType, multiline, visualMedia, typesAllowed, preview, documentId, schemaId, allowMultiple, internalSchemaId, overrideId,
        ...remainingProps } = otherProps

    const displayError = typeof errors === 'string' ? errors : null

    return (
        <Col
            valign="top"
            role="group"
            {...(title && { 'aria-labelledby': labelId })}
            {...(description && { 'aria-describedby': descriptionId })}
            {...remainingProps}
            className={classNames('WRAPPER', remainingProps.className)}
        >
            {(title || hint) && (
                <Label
                    id={labelId}
                    htmlFor={labelId?.replace('label-', 'input-')}
                    text={title}
                    required={required}
                    hint={hint}
                    bold
                    className={classNames( labelClassName, { 'm-0': description } )}
                />
            )}

            {description && (
                <Text
                    id={descriptionId}
                    className="mb-2 text-muted">
                    {description}
                </Text>
            )}

            {children}

            {displayError && (
                <Text
                    id={errorId}
                    role="alert"
                    aria-live="polite"
                    color="danger"
                    className="mt-1">
                    {displayError}
                </Text>
            )}
        </Col>
    )
})

export default Wrapper
